import { render, staticRenderFns } from "./BuildExposure.vue?vue&type=template&id=12eb09ba&scoped=true"
import script from "./BuildExposure.vue?vue&type=script&lang=js"
export * from "./BuildExposure.vue?vue&type=script&lang=js"
import style0 from "./BuildExposure.vue?vue&type=style&index=0&id=12eb09ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb09ba",
  null
  
)

export default component.exports